import { render, staticRenderFns } from "./app-part-comp.vue?vue&type=template&id=105208f6&scoped=true&"
import script from "./js/app-part-comp.js?vue&type=script&lang=js&"
export * from "./js/app-part-comp.js?vue&type=script&lang=js&"
import style0 from "./app-part-comp.vue?vue&type=style&index=0&id=105208f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105208f6",
  null
  
)

export default component.exports